/* @flow weak */
import { EVERYONE } from 'utils/roleHelpers';

export default function getRedirectLocationAfterGroupCreation(group) {
  return `/classes/${group.getCode()}/messages/announcements/${EVERYONE}?invite=true`;
}



// WEBPACK FOOTER //
// ./src/utils/getRedirectLocationAfterGroupCreation.js